import styled, { createGlobalStyle } from 'styled-components';
import { transitionDuration, transitionTiming } from '~/styles/tokens';
import { DATA_TEST_ID } from '~/test/data-test-id';

export const AppStyle = styled.div`
	margin-top: 0;
	margin-bottom: 0;
	height: 100%;
	transition-timing-function: ${transitionTiming};
	transition-duration: ${transitionDuration}ms;
	transition-property: margin-top;

	button.text-item {
		svg {
			position: relative;
			top: 4px;
		}
	}
`;

export const GlobalStyle = createGlobalStyle`
	/* * {
		&:focus, &:focus-visible {
			outline: 2px solid red !important;
		}
			
	} */

	html {
		box-sizing: border-box;
		font-size: 16px;
	}

	.sr-only {
		position: absolute;
		width: 1px;
		height: 1px;
		padding: 0;
		margin: -1px;
		overflow: hidden;
		clip: rect(0, 0, 0, 0);
		white-space: nowrap;
		border-width: 0;
	}

	*,
	*:before,
	*:after {
		box-sizing: inherit;
	}

	body,
	h1,
	h2,
	h3,
	h4,
	h5,
	h6,
	p,
	ol,
	ul {
		margin: 0;
		padding: 0;
		font-weight: normal;
	}

	ol,
	ul {
		list-style: none;
	}

	img {
		max-width: 100%;
		height: auto;
	}

	button {
		font-feature-settings: inherit;
		color: inherit;
		font-family: inherit;
		font-size: 100%;
		font-variation-settings: inherit;
		font-weight: inherit;
		line-height: inherit;
		margin: 0;
		padding: 0;
		background: unset;
		cursor: pointer;
	}

	*,
	:after,
	:before {
		--tw-border-spacing-x: 0;
		--tw-border-spacing-y: 0;
		--tw-translate-x: 0;
		--tw-translate-y: 0;
		--tw-rotate: 0;
		--tw-skew-x: 0;
		--tw-skew-y: 0;
		--tw-scale-x: 1;
		--tw-scale-y: 1;
		--tw-pan-x: ;
		--tw-pan-y: ;
		--tw-pinch-zoom: ;
		--tw-scroll-snap-strictness: proximity;
		--tw-gradient-from-position: ;
		--tw-gradient-via-position: ;
		--tw-gradient-to-position: ;
		--tw-ordinal: ;
		--tw-slashed-zero: ;
		--tw-numeric-figure: ;
		--tw-numeric-spacing: ;
		--tw-numeric-fraction: ;
		--tw-ring-inset: ;
		--tw-ring-offset-width: 0px;
		--tw-ring-offset-color: #fff;
		--tw-ring-color: #3b82f680;
		--tw-ring-offset-shadow: 0 0 #0000;
		--tw-ring-shadow: 0 0 #0000;
		--tw-shadow: 0 0 #0000;
		--tw-shadow-colored: 0 0 #0000;
		--tw-blur: ;
		--tw-brightness: ;
		--tw-contrast: ;
		--tw-grayscale: ;
		--tw-hue-rotate: ;
		--tw-invert: ;
		--tw-saturate: ;
		--tw-sepia: ;
		--tw-drop-shadow: ;
		--tw-backdrop-blur: ;
		--tw-backdrop-brightness: ;
		--tw-backdrop-contrast: ;
		--tw-backdrop-grayscale: ;
		--tw-backdrop-hue-rotate: ;
		--tw-backdrop-invert: ;
		--tw-backdrop-opacity: ;
		--tw-backdrop-saturate: ;
		--tw-backdrop-sepia: ;
		--tw-contain-size: ;
		--tw-contain-layout: ;
		--tw-contain-paint: ;
		--tw-contain-style: ;
	}
	::backdrop {
		--tw-border-spacing-x: 0;
		--tw-border-spacing-y: 0;
		--tw-translate-x: 0;
		--tw-translate-y: 0;
		--tw-rotate: 0;
		--tw-skew-x: 0;
		--tw-skew-y: 0;
		--tw-scale-x: 1;
		--tw-scale-y: 1;
		--tw-pan-x: ;
		--tw-pan-y: ;
		--tw-pinch-zoom: ;
		--tw-scroll-snap-strictness: proximity;
		--tw-gradient-from-position: ;
		--tw-gradient-via-position: ;
		--tw-gradient-to-position: ;
		--tw-ordinal: ;
		--tw-slashed-zero: ;
		--tw-numeric-figure: ;
		--tw-numeric-spacing: ;
		--tw-numeric-fraction: ;
		--tw-ring-inset: ;
		--tw-ring-offset-width: 0px;
		--tw-ring-offset-color: #fff;
		--tw-ring-color: #3b82f680;
		--tw-ring-offset-shadow: 0 0 #0000;
		--tw-ring-shadow: 0 0 #0000;
		--tw-shadow: 0 0 #0000;
		--tw-shadow-colored: 0 0 #0000;
		--tw-blur: ;
		--tw-brightness: ;
		--tw-contrast: ;
		--tw-grayscale: ;
		--tw-hue-rotate: ;
		--tw-invert: ;
		--tw-saturate: ;
		--tw-sepia: ;
		--tw-drop-shadow: ;
		--tw-backdrop-blur: ;
		--tw-backdrop-brightness: ;
		--tw-backdrop-contrast: ;
		--tw-backdrop-grayscale: ;
		--tw-backdrop-hue-rotate: ;
		--tw-backdrop-invert: ;
		--tw-backdrop-opacity: ;
		--tw-backdrop-saturate: ;
		--tw-backdrop-sepia: ;
		--tw-contain-size: ;
		--tw-contain-layout: ;
		--tw-contain-paint: ;
		--tw-contain-style: ;
	} /*! tailwindcss v3.4.17 | MIT License | https://tailwindcss.com*/
	*,
	:after,
	:before {
		border: 0 solid #e5e7eb;
		box-sizing: border-box;
	}
	:after,
	:before {
		--tw-content: '';
	}
	:host,
	html {
		line-height: 1.5;
		-webkit-text-size-adjust: 100%;
		font-family: AudiType, sans-serif;
		font-feature-settings: normal;
		font-variation-settings: normal;
		tab-size: 4;
		-webkit-tap-highlight-color: transparent;
	}
	body {
		line-height: inherit;
		margin: 0;
	}
	hr {
		border-top-width: 1px;
		color: inherit;
		height: 0;
	}
	abbr:where([title]) {
		-webkit-text-decoration: underline dotted;
		text-decoration: underline dotted;
	}
	h1,
	h2,
	h3,
	h4,
	h5,
	h6 {
		font-size: inherit;
		font-weight: inherit;
	}
	a {
		color: inherit;
	}
	b,
	strong {
		font-weight: bolder;
	}
	code,
	kbd,
	pre,
	samp {
		font-family: AudiType, sans-serif;
		font-feature-settings: normal;
		font-size: 1em;
		font-variation-settings: normal;
	}
	small {
		font-size: 80%;
	}
	sub,
	sup {
		font-size: 75%;
		line-height: 0;
		position: relative;
		vertical-align: initial;
	}
	sub {
		bottom: -0.25em;
	}
	sup {
		top: -0.5em;
	}
	table {
		border-collapse: collapse;
		border-color: inherit;
		text-indent: 0;
	}
	button,
	input,
	optgroup,
	select,
	textarea {
		color: inherit;
		font-family: inherit;
		font-feature-settings: inherit;
		font-size: 100%;
		font-variation-settings: inherit;
		font-weight: inherit;
		letter-spacing: inherit;
		line-height: inherit;
		margin: 0;
		padding: 0;
	}
	button,
	select {
		text-transform: none;
	}
	button,
	input:where([type='button']),
	input:where([type='reset']),
	input:where([type='submit']) {
		-webkit-appearance: button;
		background-image: none;
	}
	:-moz-focusring {
		outline: auto;
	}
	:-moz-ui-invalid {
		box-shadow: none;
	}
	progress {
		vertical-align: initial;
	}
	::-webkit-inner-spin-button,
	::-webkit-outer-spin-button {
		height: auto;
	}
	[type='search'] {
		-webkit-appearance: textfield;
		outline-offset: -2px;
	}
	::-webkit-search-decoration {
		-webkit-appearance: none;
	}
	::-webkit-file-upload-button {
		-webkit-appearance: button;
		font: inherit;
	}
	summary {
		display: list-item;
	}
	blockquote,
	dd,
	dl,
	figure,
	h1,
	h2,
	h3,
	h4,
	h5,
	h6,
	hr,
	p,
	pre {
		margin: 0;
	}
	fieldset {
		margin: 0;
	}
	fieldset,
	legend {
		padding: 0;
	}
	menu,
	ol,
	ul {
		list-style: none;
		margin: 0;
		padding: 0;
	}
	dialog {
		padding: 0;
	}
	textarea {
		resize: vertical;
	}
	input::placeholder,
	textarea::placeholder {
		color: #9ca3af;
		opacity: 1;
	}
	[role='button'],
	button {
		cursor: pointer;
	}
	:disabled {
		cursor: default;
	}
	audio,
	canvas,
	embed,
	iframe,
	img,
	object,
	svg,
	video {
		display: block;
		vertical-align: middle;
	}
	img,
	video {
		height: auto;
		max-width: 100%;
	}
	[hidden]:where(:not([hidden='until-found'])) {
		display: none;
	}
	.container {
		width: 100%;
	}
	@media (min-width: 375px) {
		.container {
			max-width: 375px;
		}
	}
	@media (min-width: 768px) {
		.container {
			max-width: 768px;
		}
	}
	@media (min-width: 1024px) {
		.container {
			max-width: 1024px;
		}
	}
	@media (min-width: 1440px) {
		.container {
			max-width: 1440px;
		}
	}
	@media (min-width: 1920px) {
		.container {
			max-width: 1920px;
		}
	}
	.visible {
		visibility: visible;
	}
	.static {
		position: static;
	}
	.inherit {
		position: inherit;
	}
	.absolute {
		position: absolute;
	}
	.relative {
		position: relative;
	}
	.sticky {
		position: -webkit-sticky;
		position: sticky;
	}
	.inset-0 {
		inset: 0;
	}
	.top-0 {
		top: 0;
	}
	.z-10 {
		z-index: 10;
	}
	.mx-auto {
		margin-left: auto;
	}
	.mr-auto,
	.mx-auto {
		margin-right: auto;
	}
	.mt-2 {
		margin-top: 0.5rem;
	}
	.mt-4 {
		margin-top: 1rem;
	}
	.mt-8 {
		margin-top: 2rem;
	}
	.block {
		display: block;
	}
	.inline {
		display: inline;
	}
	.flex {
		display: flex;
	}
	.grid {
		display: grid;
	}
	.contents {
		display: contents;
	}
	.hidden {
		display: none;
	}
	.aspect-square {
		aspect-ratio: 1/1;
	}
	.aspect-video {
		aspect-ratio: 16/9;
	}
	.h-32 {
		height: 8rem;
	}
	.h-6 {
		height: 1.5rem;
	}
	.h-80 {
		height: 20rem;
	}
	.h-full {
		height: 100%;
	}
	.max-h-64 {
		max-height: 16rem;
	}
	.w-6 {
		width: 1.5rem;
	}
	.w-full {
		width: 100%;
	}
	.\!max-w-\[100vw\] {
		max-width: 100vw !important;
	}
	.\!max-w-\[1150px\] {
		max-width: 1150px !important;
	}
	.max-w-medium {
		max-width: 707px;
	}
	.max-w-sm {
		max-width: 24rem;
	}
	.flex-1 {
		flex: 1 1 0%;
	}
	.shrink-0 {
		flex-shrink: 0;
	}
	.transform {
		transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate))
			skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
	}
	.resize {
		resize: both;
	}
	.list-disc {
		list-style-type: disc;
	}
	.grid-cols-2 {
		grid-template-columns: repeat(2, minmax(0, 1fr));
	}
	.grid-cols-\[auto_1fr\] {
		grid-template-columns: auto 1fr;
	}
	.flex-row {
		flex-direction: row;
	}
	.flex-col {
		flex-direction: column;
	}
	.flex-wrap {
		flex-wrap: wrap;
	}
	.place-items-center {
		place-items: center;
	}
	.items-center {
		align-items: center;
	}
	.justify-center {
		justify-content: center;
	}
	.justify-between {
		justify-content: space-between;
	}
	.justify-around {
		justify-content: space-around;
	}
	.gap-1 {
		gap: 0.25rem;
	}
	.gap-12 {
		gap: 3rem;
	}
	.gap-16 {
		gap: 4rem;
	}
	.gap-2 {
		gap: 0.5rem;
	}
	.gap-4 {
		gap: 1rem;
	}
	.gap-6 {
		gap: 1.5rem;
	}
	.gap-8 {
		gap: 2rem;
	}
	.gap-x-16 {
		column-gap: 4rem;
	}
	.gap-x-2 {
		column-gap: 0.5rem;
	}
	.gap-x-4 {
		column-gap: 1rem;
	}
	.gap-x-6 {
		column-gap: 1.5rem;
	}
	.gap-x-8 {
		column-gap: 2rem;
	}
	.gap-y-1 {
		row-gap: 0.25rem;
	}
	.gap-y-2 {
		row-gap: 0.5rem;
	}
	.place-self-end {
		place-self: end;
	}
	.overflow-hidden {
		overflow: hidden;
	}
	.rounded-full {
		border-radius: 9999px;
	}
	.border {
		border-width: 1px;
	}
	.border-b {
		border-bottom-width: 1px;
	}
	.border-b-2 {
		border-bottom-width: 2px;
	}
	.border-black {
		--tw-border-opacity: 1;
		border-color: rgb(0 0 0 / var(--tw-border-opacity, 1));
	}
	.border-grey-50 {
		--tw-border-opacity: 1;
		border-color: rgb(128 128 128 / var(--tw-border-opacity, 1));
	}
	.border-transparent {
		border-color: #0000;
	}
	.bg-\[\#4d9e29\] {
		--tw-bg-opacity: 1;
		background-color: rgb(77 158 41 / var(--tw-bg-opacity, 1));
	}
	.bg-grey-5 {
		--tw-bg-opacity: 1;
		background-color: rgb(242 242 242 / var(--tw-bg-opacity, 1));
	}
	.bg-neutral-200 {
		--tw-bg-opacity: 1;
		background-color: rgb(229 229 229 / var(--tw-bg-opacity, 1));
	}
	.bg-white {
		--tw-bg-opacity: 1;
		background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
	}
	.bg-white\/50 {
		background-color: #ffffff80;
	}
	.object-contain {
		object-fit: contain;
	}
	.object-cover {
		object-fit: cover;
	}
	.object-scale-down {
		object-fit: scale-down;
	}
	.p-12 {
		padding: 3rem;
	}
	.p-4 {
		padding: 1rem;
	}
	.p-6 {
		padding: 1.5rem;
	}
	.px-4 {
		padding-left: 1rem;
		padding-right: 1rem;
	}
	.py-3 {
		padding-bottom: 0.75rem;
		padding-top: 0.75rem;
	}
	.py-4 {
		padding-bottom: 1rem;
		padding-top: 1rem;
	}
	.\!pt-0 {
		padding-top: 0 !important;
	}
	.pb-2 {
		padding-bottom: 0.5rem;
	}
	.pt-0 {
		padding-top: 0;
	}
	.pt-12 {
		padding-top: 3rem;
	}
	.text-center {
		text-align: center;
	}
	.text-start {
		text-align: start;
	}
	.text-white {
		--tw-text-opacity: 1;
		color: rgb(255 255 255 / var(--tw-text-opacity, 1));
	}
	.underline {
		-webkit-text-decoration-line: underline;
		text-decoration-line: underline;
	}
	.antialiased {
		-webkit-font-smoothing: antialiased;
		-moz-osx-font-smoothing: grayscale;
	}
	.ring {
		--tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
		--tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(3px + var(--tw-ring-offset-width)) var(--tw-ring-color);
		box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
	}
	.drop-shadow-lg {
		--tw-drop-shadow: drop-shadow(0 10px 8px #0000000a) drop-shadow(0 4px 3px #0000001a);
		filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate)
			var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
	}
	.\!filter {
		filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate)
			var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow) !important;
	}
	.filter {
		filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate)
			var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
	}
	.transition {
		transition-duration: 0.15s;
		transition-property:
			color,
			background-color,
			border-color,
			fill,
			stroke,
			opacity,
			box-shadow,
			transform,
			filter,
			-webkit-text-decoration-color,
			-webkit-backdrop-filter;
		transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity,
			box-shadow, transform, filter, backdrop-filter;
		transition-property:
			color,
			background-color,
			border-color,
			text-decoration-color,
			fill,
			stroke,
			opacity,
			box-shadow,
			transform,
			filter,
			backdrop-filter,
			-webkit-text-decoration-color,
			-webkit-backdrop-filter;
		transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
	}
	.transition-colors {
		transition-duration: 0.15s;
		transition-property:
			color,
			background-color,
			border-color,
			fill,
			stroke,
			-webkit-text-decoration-color;
		transition-property: color, background-color, border-color, text-decoration-color, fill, stroke;
		transition-property:
			color,
			background-color,
			border-color,
			text-decoration-color,
			fill,
			stroke,
			-webkit-text-decoration-color;
		transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
	}
	.ease-out {
		transition-timing-function: cubic-bezier(0, 0, 0.2, 1);
	}
	.\[text-wrap\:balance\] {
		text-wrap: balance;
	}
	.last\:border-b-0:last-child {
		border-bottom-width: 0;
	}


	.location-search {
		@media (min-width: 1440px) {

              width: 707px;
		  }
	  > div:first-child {
        > div:first-child {
            z-index: 1;
        }
		 > div:nth-child(2) {
			 width: 707px;

          @media (max-width: 1440px) {
              width: 100%;
		  }
        }

		.inherit {
          position: inherit !important;
		}
    }
	}

	dialog.stock-car-dialog {
      & > div {
	    & > div:last-of-type {
          @media (max-width: 1440px) {
              width: 100%;
		  }
	    }
    }

	}
	@media (min-width: 768px) {
		.md\:hidden {
			display: none;
		}
		.md\:h-auto {
			height: auto;
		}
		.md\:h-full {
			height: 100%;
		}
		.md\:w-52 {
			width: 13rem;
		}
		.md\:grid-cols-2 {
			grid-template-columns: repeat(2, minmax(0, 1fr));
		}
		.md\:grid-cols-\[auto_1fr\] {
			grid-template-columns: auto 1fr;
		}
		.md\:grid-cols-\[auto_1fr_auto\] {
			grid-template-columns: auto 1fr auto;
		}
		.md\:flex-row {
			flex-direction: row;
		}
		.md\:border-b {
			border-bottom-width: 1px;
		}
		.md\:border-none {
			border-style: none;
		}
		.md\:border-black {
			--tw-border-opacity: 1;
			border-color: rgb(0 0 0 / var(--tw-border-opacity, 1));
		}
		.md\:py-0 {
			padding-bottom: 0;
			padding-top: 0;
		}
		.md\:py-4 {
			padding-bottom: 1rem;
			padding-top: 1rem;
		}
		.md\:text-start {
			text-align: start;
		}
	}
	@media (min-width: 1024px) {
		.lg\:w-fit {
			width: -webkit-fit-content;
			width: fit-content;
		}
		.lg\:px-16 {
			padding-left: 4rem;
			padding-right: 4rem;
		}
		.lg\:pt-0 {
			padding-top: 0;
		}
		.lg\:pt-16 {
			padding-top: 4rem;
		}
	}


	#${DATA_TEST_ID.TACTICAL_TRIGGER} {
		min-width: fit-content;
	}


`;
